export class Magazine {

    constructor(data) {
        this.id = data.id;
        this.name = data.name;
    }
}
